import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import ReviewStars from '$components/basic/ReviewStars';
import { Card } from '@/components/atoms/Card';

import styles from './index.module.scss';
import { ReviewQuote } from './components/ReviewQuote';
import type { AppGarageReview } from 'pages/api/getGaragesByLatLong';

interface GarageReviewSectionProps extends AppGarageReview, ComponentPropsWithoutRef<'div'> {
  readonly translations: {
    readonly reviewTitle: string;
  };
}

export function GarageReviewSection({
  rating = 4,
  text,
  authorName,
  relativeTime,
  translations: { reviewTitle },
}: GarageReviewSectionProps): ReactNode {
  if (!text) return null;

  return (
    <div className={styles.GarageReviewSection}>
      <p className={styles.ReviewTitle}>{reviewTitle}</p>
      <Card cornerRadius={1} className={styles.ReviewCard}>
        <ReviewStars className={styles.ReviewStars} stars={rating} starHeight={16} starWidth={16} />
        <ReviewQuote text={text} authorName={authorName} relativeTime={relativeTime} />
      </Card>
    </div>
  );
}

GarageReviewSection.displayName = 'GarageReviewSection';
